export function getOrderNFTImageHeight(screenWidth: number) {
  return screenWidth - 50 < 400 ? (screenWidth - 60) / 0.71111111111 : 560
}
